import { SortDirection } from '@angular/material/sort';
import Currency from 'currency.js';

import { BaseListFilter } from '../../../models/base-list-filter.model';
import { TransactionExternalServiceEnum } from './transaction-external-service.enum';
import { TransactionMethodEnum } from './transaction-method.enum';
import { TransactionPayoutStateEnum } from './transaction-payout-state.enum';
import { TransactionTypeEnum } from './transaction-type.enum';
import { TransactionWarningTypeEnum } from './transaction-warning-type.enum';

export class TransactionsFilter extends BaseListFilter {
  userId?: number;
  userName?: string;
  createdAtFrom?: Date;
  createdAtTo?: Date;
  dateFrom?: Date;
  dateTo?: Date;
  effectiveDateFrom?: Date;
  effectiveDateTo?: Date;
  defaultedAtFrom?: Date;
  defaultedAtTo?: Date;
  amountFrom?: Currency;
  amountTo?: Currency;
  unpaidAmountFrom?: Currency;
  unpaidAmountTo?: Currency;
  creditCardId?: number;
  type?: TransactionTypeEnum | TransactionTypeEnum[];
  payoutState?: TransactionPayoutStateEnum;
  method?: TransactionMethodEnum;
  externalService?:
    | TransactionExternalServiceEnum
    | TransactionExternalServiceEnum[];
  warningType?: TransactionWarningTypeEnum | TransactionWarningTypeEnum[];
  pricingPolicyId?: number;
  feeTransactionId?: number;
  externalServiceId?: string;
  descriptionContains?: string;
  fetchLoanFacilityEligible?: boolean;
  groupId?: string;
  originatedDealId?: number;
  withoutOriginatedDealId?: boolean;

  constructor(
    public sortBy: string = 'transaction.id',
    public sortDirection: SortDirection = 'desc',
  ) {
    super();
  }
}
